import { useState, useEffect } from "react";
import { VideoBackground } from "@/components/VideoBackground";
import { MinimalisticPlayer } from "@/components/MinimalisticPlayer";
import { FooterLinks } from "@/components/FooterLinks";
import { SEOHead } from "@/components/SEOHead";
import { StructuredData } from "@/components/StructuredData";
import { supabase } from "@/integrations/supabase/client";
import { useIsMobile } from "@/hooks/use-mobile";

const Index = () => {
  const [selectedAirport, setSelectedAirport] = useState<string>("");
  const [videoUrl, setVideoUrl] = useState<string | null>(null);
  const isMobile = useIsMobile();

  const handleAirportSelect = (airportCode: string) => {
    setSelectedAirport(airportCode);
  };

  // Fetch video URL for mobile player
  useEffect(() => {
    const fetchVideo = async () => {
      const { data } = supabase.storage.from('videos').getPublicUrl('background-video.mp4');
      if (data?.publicUrl) {
        setVideoUrl(data.publicUrl);
      }
    };
    fetchVideo();
  }, []);

  return (
    <>
      <SEOHead />
      <StructuredData />
      
      {/* Only show VideoBackground on desktop - mobile has it integrated in player */}
      {!isMobile && (
        <VideoBackground
          storageKey="background-video.mp4"
          title="Ambient airplane flying above clouds - Sky Lofi ATC background video"
        />
      )}
      
      <header className="absolute top-4 left-4 z-20 max-w-md">
        <h1 className="text-lg md:text-xl font-semibold text-foreground/90 drop-shadow-lg">
          Sky Lofi ATC
        </h1>
        <p className="sr-only">Stream free ambient lofi music mixed with real-time ATC radio communications from major international airports worldwide. Perfect 24/7 background music for studying, coding, working, and deep concentration.</p>
      </header>

      <main role="main">
        <MinimalisticPlayer 
          selectedAirport={selectedAirport}
          onAirportSelect={handleAirportSelect}
          videoUrl={videoUrl}
        />
      </main>

      <FooterLinks />
    </>
  );
};

export default Index;
